<div>
    @if (isAuthenticated$ | async) {
        <div class="content">
            <ui-logo
                [small]="true"
                class="logo"></ui-logo>
            <h1>Password Connection Works</h1>
            <p>The tested password connection works with the Bannerflow platform!</p>
        </div>
    }
</div>
